/**
 * Returns a label string based on the user's login status, selection, and article properties.
 *
 * @param {Object} params - The parameters for determining the label.
 * @param {boolean} params.isLogged - Indicates if the user is logged in.
 * @param {boolean} params.isSelected - Indicates if the newsletter/article is selected.
 * @param {boolean} params.isPremium - Indicates if the article is premium.
 * @param {boolean} params.isExclusive - Indicates if the article is exclusive.
 * @returns {string} The appropriate label for the newsletter/article.
 */
export function getLabel({
  isLogged,
  isSelected,
  isPremium,
  isExclusive = false,
}) {
  if (!isPremium && isExclusive && !isSelected) return "SUSCRIBITE";
  if (isLogged && isSelected) return "RECIBIENDO";
  if (isLogged && !isSelected) return "RECIBIR NEWSLETTER";
  if (isSelected) return "SELECCIONADO";
  return "SELECCIONAR";
}
